<template>
    <section class="gmp-section gmp-mb-l">

        <div class="subpage-hero">
            <div class="two-column-tout">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6 h-c-grid__col-xl--5  h-c-grid__col--align-middle
            two-column-tout__content">
                            <h1 class="h-c-headline h-c-headline--display-two h-has-bottom-margin">
                                帮助客户降低原料成本
                            </h1>
                            <div class="h-u-mb-std two-column-tout__description">
                                <p>
                                    专业配送小程序与时鲜管理系统之间的集成，
                                    两个系统共享数据，并确保相关信息在两个系统之间实时同步，从而优化业务流程和运营效率。
                                    </p>
                            </div>

                        </div>

                        <div class="h-c-grid__col  h-c-grid__col-l--6  h-c-grid__col--align-middle">
                            <div class="two-column-tout__image text-center">
                                <picture>
                                    <img src="@/assets/img/subpage.png" alt="" class="gmp-no-grab ">
                                </picture>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>


    </section>
</template>

<script>
    export default {
        name: "DIS_subpagehero"
    }
</script>

<style lang="less">


</style>